/**
 * Company contact information and configuration.
 * Mirrors main website structure for consistency.
 */

export const COMPANY_INFO = {
  contact: {
    email: {
      feedback: 'alannguyen@tadreamk.com',
      support: 'support@tadreamk.com',
      business: 'business@tadreamk.com'
    }
  }
};

